/**
 * @author Vlad
 */
var typeBindings = { type: '=' };
var DealRegistrationProductGroupController = (function () {
    function DealRegistrationProductGroupController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.props = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'gbt20ID',
            'gbt20Name',
            'revenue',
            'bpa',
            'ta',
            'value',
            'bpDuplicateFound',
            'bpDuplicateOpportunityNumber',
            'ibmDuplicateFound',
            'ibmDuplicateOpportunityNumber',
            'specialBid',
            'cvrSSA',
            'solution',
            'solutionID'
        ];
        this.propsV4 = [];
        this.propsV5eligibility = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'bpa',
            'ta',
            'value',
            'bpDuplicateFound',
            'bpDuplicateOpportunityNumber',
            'cvrSSA',
            'solution',
            'solutionID',
        ];
        this.propsV4eligibility = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'gbt20ID',
            'gbt20Name',
            'revenue',
            'bpa',
            'ta',
            'value',
            'bpDuplicateFound',
            'bpDuplicateOpportunityNumber',
            'specialBid',
            'cvrSSA',
            'solution',
            'solutionID',
        ];
        this.propsV4validation = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'gbt20ID',
            'gbt20Name',
            'salesIncentive',
            'engagement',
            'engagementID',
            'growthIncentive',
            'focusIncentive',
        ];
        this.propsV5validation = [
            'dealRegProductGroupID',
            'dealRegProductGroupName',
            'salesIncentive',
            'engagement',
            'engagementID',
            'growthIncentive',
            'focusIncentive',
        ];
        this.revenueStr = 'revenue';
        this.DRPGsArr = [];
        this.tableName = 'Deal Registration Product Group';
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.initTableColumns();
        this.socket.forward('eligibility.getDealRegProductGroupData', this.$scope);
        this.$scope.$on('socket:eligibility.getDealRegProductGroupData', function (event, data /*ITableData*/) {
            _this.tableHeader = Array.isArray(data.header) ? data.header.map(function (h) { return h.value; }) : data.header;
            _this.tableRows = data.rows;
            _this.tableRows.forEach(function (item, i) {
                if (_this.tableRows[i + 1] && _this.tableRows[i + 1].dealRegProductGroupID === _this.tableRows[i].dealRegProductGroupID && _this.tableRows[i + 1].cvrSSA === _this.tableRows[i].cvrSSA
                    && _this.tableRows[i + 1].solution === _this.tableRows[i].solution && _this.type === 'validation') {
                    for (var el in item) {
                        item[el] = _this.getDRPGelem(item, el, i);
                    }
                    _this.DRPGsArr.push(item);
                    _this.tableRows.splice(i + 1, 1);
                }
                else {
                    for (var el in item) {
                        item[el] = Array.isArray(item[el]) || _this.type !== 'validation' ? item[el] : [item[el]];
                    }
                    _this.DRPGsArr.push(item);
                }
            });
            _this.tableError = data.error || '';
            _this.url = _this.topic.$state.current.name.split('.')[1];
        });
    }
    DealRegistrationProductGroupController.prototype.initTableColumns = function () {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            this.propsV4 = this.type === 'validation' ? this.propsV5validation : this.propsV5eligibility;
        }
        else {
            this.propsV4 = this.type === 'validation' ? this.propsV4validation : this.propsV4eligibility;
        }
    };
    DealRegistrationProductGroupController.prototype.getDRPGelem = function (item, el, i) {
        if (el === this.revenueStr) {
            return [Number.parseInt(item[this.revenueStr]) + Number.parseInt(this.tableRows[i + 1][this.revenueStr])];
        }
        if (typeof item[el] === 'string' && el !== this.revenueStr) {
            return item[el] === this.tableRows[i + 1][el] ? [item[el]] : [item[el], this.tableRows[i + 1][el]];
        }
        if (Array.isArray(item[el])) {
            var mergedArrs_1 = item[el].concat(this.tableRows[i + 1][el]);
            return mergedArrs_1.filter(function (item, pos) {
                return mergedArrs_1.indexOf(item) == pos;
            });
        }
    };
    DealRegistrationProductGroupController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DealRegistrationProductGroupController.prototype.$onInit = function () {
        this.getDealRegProductGroupData();
    };
    DealRegistrationProductGroupController.prototype.getDealRegProductGroupData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id.substring(4),
                    type: this.type
                },
                function: 'getDealRegProductGroupData',
                script: '/detail/eligibility/drpgResult/index',
                token: this.env.user.token
            }
        });
    };
    DealRegistrationProductGroupController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DealRegistrationProductGroupController;
}());
var DealRegistrationProductGroupComponent = (function () {
    function DealRegistrationProductGroupComponent() {
        this.templateUrl = 'deal-registration-product-group.html';
        this.controllerAs = 'vm';
        this.bindings = typeBindings;
        this.controller = DealRegistrationProductGroupController;
    }
    return DealRegistrationProductGroupComponent;
}());
angular
    .module('application')
    .component('dealRegistrationProductGroup', new DealRegistrationProductGroupComponent());

//# sourceMappingURL=detail.table.dealreg.product.group.component.js.map
